import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { List, X, ArrowUpRight, Globe } from "@phosphor-icons/react";
import { useI18n } from "@/i18n";

const linkDefs = [
  { href: "#inicio", key: "inicio" },
  { href: "#catalogo", key: "catalogo" },
  { href: "#marcas", key: "marcas" },
  { href: "#ventajas", key: "ventajas" },
  { href: "#registro", key: "registro" },
  { href: "#contacto", key: "contacto" },
];

export function Nav() {
  const { t, toggle } = useI18n();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="bg-[#ff4500] text-[#050505] text-[11px] md:text-xs font-mono font-medium py-2 px-4 text-center tracking-wide">
        {t.nav.notice}
      </div>
      <header
        data-testid="site-header"
        className={`sticky top-0 z-50 transition-colors duration-300 border-b ${
          scrolled ? "bg-black/85 backdrop-blur-xl border-white/10" : "bg-black/40 backdrop-blur-md border-transparent"
        }`}
      >
        <div className="w-full max-w-screen-2xl mx-auto px-4 md:px-8 h-20 flex items-center justify-between">
          <a href="#inicio" className="flex items-center gap-3" data-testid="logo">
            <img src="/esoesly-tile.png" alt="ESOESLY" className="w-9 h-9 rounded-md" />
            <span className="font-clash font-black text-xl tracking-tight text-[#f5f5f5] leading-none">
              ESO<span className="text-[#ff4500]">ESLY</span>
            </span>
            <span className="hidden sm:block font-mono text-[10px] text-[#a3a3a3] tracking-[0.3em] uppercase border-l border-white/10 pl-3">
              {t.nav.tagline}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8 font-mono text-[13px] uppercase tracking-wider text-[#a3a3a3]">
            {linkDefs.map((l) => (
              <a key={l.href} href={l.href} className="hover:text-[#f5f5f5] transition-colors duration-200">
                {t.nav.links[l.key]}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={toggle}
              data-testid="lang-toggle"
              className="flex items-center gap-1.5 font-mono text-[12px] uppercase tracking-wider text-[#a3a3a3] hover:text-[#ff4500] transition-colors"
              aria-label="language"
            >
              <Globe size={16} /> {t.lang.switch}
            </button>
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="hidden lg:block font-mono text-[12px] uppercase tracking-wider text-[#a3a3a3] hover:text-[#f5f5f5] transition-colors"
            >
              {t.nav.admin}
            </Link>
            <a
              href="#registro"
              data-testid="nav-cta"
              className="group hidden sm:flex items-center gap-2 bg-[#ff4500] hover:bg-[#e03c00] text-[#050505] text-[13px] font-semibold px-5 py-2.5 transition-colors"
            >
              {t.nav.cta}
              <ArrowUpRight size={16} weight="bold" className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
            <button
              className="md:hidden text-[#f5f5f5]"
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-toggle"
              aria-label="menu"
            >
              {open ? <X size={26} /> : <List size={26} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden bg-black/95 border-t border-white/10 px-4 py-6 flex flex-col gap-4 font-mono uppercase text-sm text-[#a3a3a3]">
            {linkDefs.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="hover:text-[#ff4500]">
                {t.nav.links[l.key]}
              </a>
            ))}
            <Link to="/admin" onClick={() => setOpen(false)} className="hover:text-[#ff4500]">{t.nav.admin}</Link>
          </div>
        )}
      </header>
    </>
  );
}
